import { render } from "./MmProductCreate.vue?vue&type=template&id=0b52f146"
import script from "./MmProductCreate.vue?vue&type=script&lang=js"
export * from "./MmProductCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__